<template>
  <v-card class="chat" v-if="group.msg_group_id">
      <v-toolbar dark color='primary'>
          <v-btn @click='group=null' icon><v-icon>mdi-close</v-icon></v-btn>
          <v-spacer></v-spacer>
          <v-toolbar-title>
            <span v-if='!editName'>{{group.name}}</span>
            <v-text-field @keydown.enter='changeGroupName' v-else hide-details class='mt-0' id='nameInput' v-model='nameTemp' filled dense style='font-size:1em' :disabled='!editName'></v-text-field>
          </v-toolbar-title>
          <v-btn v-if='!editName' icon @click='editName=true; nameTemp=group.name;' class='mr-0 pr-0'><v-icon>mdi-pencil</v-icon></v-btn>
          <v-spacer></v-spacer>
          <v-btn v-if="group.phone_number && !session" icon v-on:click="callGroup(group)"><v-icon>mdi-phone</v-icon></v-btn>
          <div v-if="(activeConferenceId && (group.conference_id == activeConferenceId))" >
            <v-menu 
              v-model='confParticipantsMenu' 
              offset-x left 
              :close-on-content-click="false"
              max-width="400"
              min-width="400"
            >
              <template v-slot:activator='{ on, attrs }'>
                <v-btn 
                  icon 
                  fab 
                  small 
                  dark 
                  color="yellow" 
                  v-bind='attrs' 
                  v-on='on'
                >
                    <v-icon>mdi-account-group</v-icon>
                </v-btn>
              </template>
              <v-card>
                <conference-participant-list></conference-participant-list>
                <v-card-text>
                  <conference-joining-info></conference-joining-info>
                </v-card-text>
              </v-card>
            </v-menu>
            <v-btn 
              v-if="session.state == 'Established' &&  activeParticipants && (!session.isMuted && !myChannel.id) || (!myChannel.muted && myChannel.id)" 
              @click='myChannel.id !== null ? muteCaller(myChannel) : $sip.mute(true)' 
              color="teal" 
              dark
              fab
              small
              icon
            >
                <v-icon>mdi-microphone</v-icon>
            </v-btn>
            <v-btn 
              v-if="session.state == 'Established' && activeParticipants && (session.isMuted && !myChannel.id) || (myChannel.muted && myChannel.id)" 
              @click='myChannel.id !== null ? unmuteCaller(myChannel) : $sip.mute(false)' 
              color="teal" 
              dark
              fab
              small
              icon
            >
                <v-icon>mdi-microphone-off</v-icon>
            </v-btn>
            <v-btn v-on:click="$sip.bye()" 
                  icon
                  small 
                  dark 
                  color="red" 
                  fab>
              <v-icon >mdi-phone-hangup</v-icon>
            </v-btn>
          </div>
          <v-menu v-if="(!activeConferenceId && ((group.conference_id != activeConferenceId) || !group.conference_id))" v-model='memberMenu'  offset-x left style='background-color:#2F3136' :close-on-content-click="false">
            <template v-slot:activator='{ on, attrs }'>
              <v-btn icon  v-bind='attrs' v-on='on'>
                  <v-icon>mdi-account-group</v-icon>
              </v-btn>
            </template>
            <v-card width='250px' class='pa-0'>
              <v-card-title>Group Members</v-card-title>
              <v-list class='ma-0' rounded>
                <v-list-item v-for='m in group.MsgGroupMembers' :key="m.msg_group_member_id" class='px-2'>
                <v-list-item-icon class='mr-3 my-2 py-0'>
                  <div id='profileImage'>
                      <span>{{someCleanUp(m.name)}}</span>
                  </div>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text='m.name'></v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn small icon @click='removeMember(m)'>
                    <v-icon color='red'>mdi-close-circle</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              </v-list>
              <v-card-actions>
                <v-btn  block @click='addMemberMenu = !addMemberMenu'><v-icon>mdi-plus</v-icon>Add to Group</v-btn>
              </v-card-actions>
              <v-card-actions>
                <div v-if='addMemberMenu'>
                  <v-text-field filled dense hide-details label='E-Mail' v-model='addEmail' append-icon="mdi-plus-circle" @click:append='addEmailContact(); addMemberMenu=false'></v-text-field>
                </div>
              </v-card-actions>
            </v-card>
            <v-card width='250px' class='pa-0' v-if="queue">
              <v-card-title>Phone Agents</v-card-title>
              <v-list class='ma-0' rounded>
                <v-list-item v-for='qd in queue.AstQueueDevices' :key="qd.ast_queue_device_id" class='px-2'>
                <v-list-item-icon class='mr-3 my-2 py-0'>
                  <div id='profileImage'>
                      <span>{{someCleanUp(qd.device_name)}}</span>
                  </div>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title v-text='qd.device_name'></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              </v-list>
              <v-card-actions>
                <v-btn v-if="subscribedToQueue" @click='subscribeToQueue'>Unsubscribe to calls</v-btn>
                <v-btn v-if="!subscribedToQueue" @click='unsubscribeFromQueue'>Subscribe to calls</v-btn>                
              </v-card-actions>
            </v-card>
          </v-menu>
      </v-toolbar>
      <div v-if="showMessages" v-on:scroll.passive="handleMessagesScroll" class="messages pb-4" id="messages" style='overflow-y:auto;'>
        
          <v-row v-if="gettingMessages" style='text-align:center' no-gutters>
            <v-col>
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </v-col>
          </v-row>
        
        <template v-for='m, index in group.Messages'>
          <v-card :key='m.message_id' flat color='transparent' v-if='m && m.text' class='mx-0'>
            <v-row v-if="m.message_type != 'system'" style='text-align:start' no-gutters :class='(index==0 || group.Messages[index-1].from_id != m.from_id) ? "mt-4 mr-1" : "mt-1 mr-1"'>
              <v-col cols='2' sm='1'>
                  <div id='profileImage' v-if='index==0 || group.Messages[index-1].from_id != m.from_id' :class='$vuetify.breakpoint.mobile ? "ml-4" : "ml-5"'>
                      <span >{{someCleanUp(m.fromName)}}</span>
                  </div>
              </v-col>
              <v-col cols='10' sm='11' :class='$vuetify.breakpoint.mobile ? "pl-2" : "pl-0"'>
                <div v-if='index==0 || group.Messages[index-1].from_id != m.from_id'>
                  <span style='font-size:1em;'><b>{{m.fromName+" "}}</b></span>
                  <v-icon v-if='m.from_type=="smsnumber"'>mdi-message-text-outline</v-icon>
                  <span class='ml-2' style='color:gray; font-size:0.75em'>{{ (new Date(parseInt(m.dated))).toLocaleString("en-US") }}</span>
                </div>
                <v-card v-if="m.message_type=='voicemail'">
                  <v-list-item three-line>
                    <v-list-item-content>
                    <div class="text-overline mb-4">
                      <v-icon>mdi-voicemail</v-icon> Voicemail ({{ (new Date(parseInt(m.dated))).toLocaleString("fr-CA", { hour12: true }) }})
                    </div>
                    
                    <v-card-text class="pa-0 ma-0">
                      <span  v-html="m.text"></span>
                    </v-card-text>
                  </v-list-item-content>
                    <v-list-item-avatar
                      tile
                      size="80"
                    >
                      <v-btn large icon v-on:click="playVoicemail(m)">
                        <v-icon v-if="m.showVMPauseButton">mdi-pause-circle</v-icon>
                        <v-icon v-if="!m.showVMPauseButton">mdi-play-circle</v-icon>
                      </v-btn>
                      
                    </v-list-item-avatar>
                  </v-list-item>
                </v-card>
                <v-card-text v-if="m.message_type!='voicemail'" class='pa-0 ma-0'>
                  <span class="msg" v-html="m.text"></span>
                </v-card-text>
                <v-card elevation="0" v-if="m.file_s3_key && m.message_type != 'voicemail'" class='pa-0 ma-0'>
                  <v-card-actions>
                    <span class="text-xs-left">
                        <v-icon v-on:click="downloadAttachment(m)">description</v-icon>
                        <br>{{ m.file_original_name }}
                    </span>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
            <v-row v-if="m.message_type=='system'">
              <v-col cols="12">
                <div>
                  <span style="font-size:0.9em">{{m.text}}</span><br>
                  <span style="font-size:0.7em">{{ (new Date(parseInt(m.dated))).toLocaleString("en-US") }}</span>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </template>
        <template v-for='m, index in unsentMessages'>
          <v-card :key='index' flat color='transparent' class='mx-0' >
            <v-row style='text-align:start' no-gutters :class='(group.Messages.length == 0 || group.Messages[group.Messages.length-1].from_id != m.user_id) ? "mt-4 mr-1" : "mt-1 mr-1"'>
              <v-col cols='2' sm='1'>
                  <div id='profileImage' v-if='group.Messages.length == 0 || group.Messages[group.Messages.length-1].from_id != m.user_id' :class='$vuetify.breakpoint.mobile ? "ml-4" : "ml-5"'>
                      <span>{{someCleanUp($store.state.user.fullName)}}</span>
                  </div>
              </v-col>
              <v-col cols='10' sm='11' :class='$vuetify.breakpoint.mobile ? "pl-2" : "pl-0"'>
                <div v-if='group.Messages.length == 0 || group.Messages[group.Messages.length-1].from_id != m.user_id'>
                  <span style='color:white; font-size:1em;'><b>{{$store.state.user.fullName+" "}}</b></span>
                </div>
                <v-card-text class='pa-0 ma-0'>
                  <span style='color:#969696' v-html="m.message"></span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </template>
      </div>

      
      <v-toolbar>

        <VueEditor
          v-if="!attachment"
          id="vueEditor"
          v-model="newMessage"
          :editorOptions="editorOptions"        
          class="vueEditor"
        ></VueEditor>
<!--
  v-on:text-change="handleKeyDown"

        <v-textarea v-if="!attachment"
              style='border-radius:0px;'
              hide-details
              auto-grow 
              rows='1' 
              :label='"Message " + group.name' 
              v-model="newMessage" 
              @keyup="catchEnter" 
              append-icon='mdi-send'
              @click:append='sendMessage'
        >
        </v-textarea>
-->
        <v-btn icon v-if="!attachment"
           @click="sendMessage"
        ><v-icon>mdi-send</v-icon>
        </v-btn>
        <v-btn  v-if="!attachment" icon
           @click="getAttachment"
        ><v-icon>mdi-plus</v-icon></v-btn>
        <v-file-input id="fileUpload" ref="file" v-model="attachment" append-icon="mdi-send" @click:append='sendMessageAttachment' :class="{invisible: !attachment}"></v-file-input> 
      </v-toolbar>
  </v-card>
</template>

<script >


const scrollToBottom = function () {
        let messages = document.getElementById('messages');
        messages.scrollTop = messages.scrollHeight;
        setTimeout(() => {
            messages.scrollTop = messages.scrollHeight;
        }, 400);
}
 

import ChatMenu from '../components/ChatMenu.vue';
import ChatCommon from '../mixins/chatcommon.vue';
import Common from '../mixins/common.vue';
import ConferenceCommon from '../mixins/conferencecommon.vue';
import GroupMessages from '../components/GroupMessages.vue';
import GroupMembers from '../components/GroupMembers.vue';
import gql from 'graphql-tag'
import Vue from 'vue';
import ConferenceParticipantList from '../components/conference-participant-list.vue';
import ConferenceJoiningInfo from '../components/conference-joining-info';
import ConferenceGuestJoin from '../components/conference-guest-join';
import { VueEditor } from "vue2-editor/dist/vue2-editor.core.js";
//import Vue2Editor from "vue2-editor";

const messagesQry = gql`
  query messagesQry($groupId: Int!, $limit: Int, $lastMessageId: Int) {
    groupMessages(groupId: $groupId, limit: $limit, lastMessageId: $lastMessageId) {
      message_id
      to_id
      to_type
      from_id
      from_type
      text
      dated
      msg_group_id
      fromName
      toName
      groupBy
      unread
      readdate
      message_type
      file_s3_bucket
      file_s3_key
      file_s3_region
      file_original_name
      file_content_type
      file_size
    }
  }
  `;

let updateGroupNameTxt = `
    mutation msgGroupRename($msgGroupId: Int!, $name: String!) {
      msgGroupRename(msgGroupId:$msgGroupId, name:$name) {
        msg_group_id
        name
      }
    }
  `;

let addUserToMsgGroupTxt = `
    mutation addUserToMsgGroup($input: AddEmailContactInput) {
      addUserToMsgGroup(input: $input) {
        msg_group_member_id
        msg_group_id
        reference_entity_id
        reference_entity_type
        name
      }
    }
  `;

let removeMsgGroupMemberTxt = `
    mutation removeMsgGroupMember($input: MsgGroupMemberInput) {
      removeMsgGroupMember(input: $input)
    }
  `;

const groupMembersQry = gql`
  query groupMembersQry($groupId: Int!) {
    groupMembers(groupId: $groupId) {
      msg_group_member_id
      msg_group_id
      reference_entity_id
      reference_entity_type
      name
      subname
      unread_messages
      errorMessage
    }
  }
  `;

const queueForMsgGroupQry = gql`
  query queueForMsgGroupQry($groupId: Int!) {
    queueForMsgGroup(groupId: $groupId) {
      ast_queue_id
      name
      account_id
      timezone
      cnam_to_queue_name
      member_join_exit_pin
      msg_group_id
      AstQueueDevices {
        ast_queue_device_id
        device_id
        device_name
        device_status
        ast_queue_id
        ringinuse
        paused
      }
    }
  }
  `;

const groupNumberQry = gql`
  query groupNumberQry($groupId: Int!) {
    groupNumber(groupId: $groupId) {
      phone_number
      conference_id
    }
  }
  `;

  import download from '../classes/download.js';
export default Vue.extend({
  mixins: [ChatCommon, ConferenceCommon, Common],
  props: [
    'localuid',
  ],
  components: {
    'ChatMenu': ChatMenu,
    'GroupMessages': GroupMessages,
    'group-members': GroupMembers,
    'conference-participant-list': ConferenceParticipantList,
    'conference-joining-info': ConferenceJoiningInfo,
    'conference-guest-join': ConferenceGuestJoin,
    VueEditor,
  },
  computed: {
    group: {
      get: function() {
        return this.$store.state.activeMsgGroup;
      },
      set: function(newval) {
        this.$store.commit('activeMsgGroup', newval);
      }
    },
    showMessages: {
      get: function() {
        return this.pShowMessages;
      },
      set: function(newval) {
        if (newval == true) {
          this.pShowMembers = false;
        }
        this.pShowMessages = newval;
      }
    },
    showMembers: {
      get: function() {
        return this.pShowMembers;
      },
      set: function(newval) {
        if (newval == true) {
          this.pShowMessages = false;
        }
        this.pShowMembers = newval;
      }
    },
    subscribedToQueue: {
      get: function() {
        if (!this.queue)
          return false;
        
        if (!this.queue.AstQueueDevices)
          return false;

        for (let i=0;i<this.queue.AstQueueDevices.length;i++) {
          let qd = this.queue.AstQueueDevices[i];
          console.log('qd.device_id: ' + qd.device_id + ' this.$store.state.deviceId: ' + this.$store.state.deviceId);
          if (qd.device_id == this.$store.state.deviceId) {
            console.log('subscribed to queue');
            return true;
          }
        }

        console.log('not subscribed to queue');
        return false;
      }
    },
    unsentMessages: {
      get: function() {
        return this.$store.state.unsentMessages;
      },
      set: function(newval) {
        this.$store.commit('unsentMessages', newval);
      }
    },
  },
  data () {
    return {
      showRenameModal: false,
      pShowMessages: true,
      pShowMembers: false,
      newMessage: '',
      chat_scroll_toggle: false,
      isPersonal: true,
      //messages: [],
      editName: false,
      memberMenu:false,
      confParticipantsMenu: false,
      addMemberMenu:false,
      addEmail: null,
      addName: '',
      gettingMessages: false,
      queue: {},
      attachment: null,
      editorOptions: {
        modules: {
          toolbar: false,
        },
      },
    }
  },
  methods: {
    debug: function(e) {
        console.log('debug: ', e);
    },
    getAttachment: function(e) {
      let fileUpload = document.getElementById('fileUpload')
      if (fileUpload != null) {
        fileUpload.click()
      }
    },
    handleImageAdded: function (file, Editor, cursorLocation, resetUploader) {
      console.log('handleImageAdded');
      console.log(file);
      return;
      var formData = new FormData();
      formData.append("file", file);
      var vuex = window.localStorage.getItem('vuex')
      var token = JSON.parse(vuex);

      axios({
        url: this.base_url + "/file/fileupload",
        method: "POST",
        data: formData,
        headers: {'Authorization': 'Bearer ' + token.auth.userToken}
      }).then(result => {
        let url = result.data.filePath; // Get url from response
        Editor.insertEmbed(cursorLocation, "image", url);
        resetUploader();
      }).catch(err => {
        alert('yukleme basarisiz! ' + err)
      });
    },
    addEmailContact: function() {
      let self = this;      
      let variables = {
        input: {
            name: this.addName,
            email: this.addEmail,
            msg_group_id: this.group.msg_group_id,
        }
      };
      const gqlClient = global.gqlClient();
      gqlClient.request(addUserToMsgGroupTxt, variables).then(function(result) {
        let msgGroupMember = result.addUserToMsgGroup;
        if (msgGroupMember) {
          self.group.MsgGroupMembers.push(msgGroupMember);
          self.email = '';
        } else {
          self.emailErrorTxt = m.errorMessage;
        }
      });
      this.addEmail=null;
    },
    earliestMessageId: function() {
      if (!this.group.Messages || this.group.Messages.length == 0) {
        return null;
      }
      return this.group.Messages[0].message_id; 
    },
    someCleanUp: function(val) {
      if (val) {
        val.match(/\b\w/g).join('')
      } else {
        return val;
      }
    },
    handleMessagesScroll: async function(evt, args) {
      let messages = document.getElementById('messages');
      if (messages.scrollTop == 0) {
        
        let oldScrollHeight = messages.scrollHeight;
        
        await this.getMessages();
        let newScrollHeight = messages.scrollHeight;
        
        let diff = newScrollHeight - oldScrollHeight;

        messages.scrollTop = diff;
      }
    },
    callGroup: function(group) {
      // vuex store keeps track of which conference is the active conference
      // so when you send mute commands, it sends that conference's ID
      this.$store.dispatch('conference/getConference', group.conference_id);

      // dial into the conference
      this.$sip.dial(group.phone_number);
    },
    subscribeToQueue: async function() {
      if (this.queue) {
        setTimeout(async () => {
          console.log('running getMsgGroupQueue');
          this.getMsgGroupQueue();
        }, 5500);
        await this.$sip.dial('Q_' + this.queue.ast_queue_id + '_' + this.$store.state.deviceId);
        await this.getMsgGroupQueue();
      }
    },
    unsubscribeFromQueue: async function() {
      if (this.queue) {
        setTimeout(async () => {
          console.log('running getMsgGroupQueue');
          this.getMsgGroupQueue();
        }, 5500);

        this.$sip.dial('Q_' + this.queue.ast_queue_id + '_' + this.$store.state.deviceId);          
      }
    },
    backToChats: function() {
      this.$router.push('/chats');
    },
    playVoicemail: async function(message) {
      
      if (typeof message.audio != 'undefined' && !message.audio.paused){
          message.audio.pause();
          message.audio.currentTime = 0;
          Vue.set(message, 'showVMPauseButton', false);
      } else {  
        message.audio = new Audio(
          global.expressAPIUrl + "/message/file" +
                                              "?file_s3_key=" + message.file_s3_key +
                                              "&file_s3_bucket=" + message.file_s3_bucket
        );  
        message.audio.type = 'audio/wav';
        try {
              message.audio.play();
              Vue.set(message, 'showVMPauseButton', true);
              message.audio.onended = function() {
                  Vue.set(message, 'showVMPauseButton', false);
              };
        } catch (err) {
              console.log('Failed to play...' + err);
        }
      }
      
    },
    downloadAttachment: async function(message) {
      let url = global.expressAPIUrl + "/message/file" +
                                   "?file_s3_key=" + message.file_s3_key +
                                   "&file_s3_bucket=" + message.file_s3_bucket;
      
      // write code to download a file from a url
      // https://stackoverflow.com/questions/13405129/javascript-create-and-save-file

      
      fetch(url, {
          method: 'GET',
      }).then(function(resp) {
        //download(resp.blob);
        return resp.blob();
      }).then(function(blob) {
        download(blob, message.file_original_name, message.file_content_type);
      });

    },
    showGroupRename: function() {
      this.showRenameModal = true;
      //console.log('abotu to show group rename');
      //console.log(this.group);
      //this.$router.push({name: 'grouprename', params: {group: this.group, localuid: this.local_uid}});
    },
    closeRenameDialog: function() {
      this.showRenameModal = false;
    },
    catchEnter: function(e) {
      console.log('catching enter');
      if (e.keyCode == 13)
      {
        if (e.shiftKey === true) { return true; }
        else { this.sendMessage(); }
        return false;
      }
    },
    changeGroupName: function() {
      let self = this;
       
      this.editName=false;
      const gqlClient = global.gqlClient();
      let variables = {
          msgGroupId: parseInt(self.group.msg_group_id),
          name: this.nameTemp
      }
      gqlClient.request(updateGroupNameTxt, variables)
      .then(function(result) {
          let g = result.msgGroupRename;
          self.group.name = g.name;
          //self.group.name = this.nameTemp;
      });
    },
    removeMember: function(msgGroupMember) {
      let self = this;      
      let variables = {
        input: {
            msg_group_member_id: msgGroupMember.msg_group_member_id,
            msg_group_id: msgGroupMember.msg_group_id,
        }
      };
      const gqlClient = global.gqlClient();
      gqlClient.request(removeMsgGroupMemberTxt, variables).then(function(result) {
        if (result.removeMsgGroupMember == true) {
          // get index of object with the msg_group_member_id
          let removeIndex = self.group.MsgGroupMembers.map(function(item) { return item.msg_group_member_id; }).indexOf(msgGroupMember.msg_group_member_id);
          // remove object
          self.group.MsgGroupMembers.splice(removeIndex, 1);
        }
      })
    },
    sendMessage: async function() {
      if (this.newMessage.trim()=='') { return; }
      this.newMessage = this.newMessage.replace(/<p><br><\/p>/gm, "");
      
      // replace '<p><br></p>' with '' in the newMessage
      
      
      console.log(this.newMessage);
      global.api.userAction('msg_send', null, 'webphone');
      
      // take out rich text / html tags on this.newMessage
      const plainTextMessage = this.newMessage.replace(/<[^>]*>?/gm, '').trim();
      console.log("Plain text message to send:", plainTextMessage);
      // --- End: Strip HTML tags for sending ---

      let unsentMessage = {message: plainTextMessage, user_id: this.$store.state.user.user_id};
      this.unsentMessages.push(unsentMessage);
      scrollToBottom();

      // Ensure there's actual text content OR an attachment before sending
      if (plainTextMessage || this.attachment) {
        // Use the plainTextMessage variable in the dispatch payload
        // If plainTextMessage is empty but there's an attachment, send a space or handle as required by your backend.
        await this.$store.dispatch('messageAdd', {
            msg_group_id: this.group.msg_group_id,
            text: plainTextMessage || " ", // Send a space if only attachment exists
            attachment: this.attachment
        });
      } else {
        // If no text content remains after stripping AND there's no attachment,
        // remove the message added optimistically to the unsent list.
        this.unsentMessages.pop();
        console.log("Message empty after stripping HTML and no attachment; not sent.");
        // Clear the editor since the message wasn't sent
        Vue.set(this, 'newMessage', '');
        return; // Stop execution here
      }

      this.attachment = null;
      
      Vue.set(this, 'newMessage', '');
      console.log('sent, new message is: ' + this.newMessage);
      scrollToBottom();
    },
    sendMessageAttachment: async function() {
      if (!this.attachment) { return; }
      global.api.userAction('msg_send', null, 'webphone');
      let unsentMessage = {message: this.newMessage, user_id: this.$store.state.user.user_id};
      this.unsentMessages.push(unsentMessage);
      scrollToBottom();
      await this.$store.dispatch('messageAdd', {  msg_group_id: this.group.msg_group_id, text: " ", attachment: this.attachment} );
      this.attachment = null;
      this.newMessage='';
      scrollToBottom();
    },
    getMessages: async function() {
      this.gettingMessages = true;
      var currentGroup = this.group
      const variables = { 
        groupId: currentGroup.msg_group_id,
        limit: 40,
        lastMessageId: this.earliestMessageId(),
      }
      let result = await global.apollo.query({ query: messagesQry, variables, fetchPolicy: 'network-only' });

      
      if (!currentGroup.Messages) {
        Vue.set(currentGroup, 'Messages', result.data.groupMessages);
        this.gettingMessages = false;
        return true;
      }
    
      let msgs = currentGroup.Messages;
      if (!msgs) msgs = [];

      for (let i=0;i<result.data.groupMessages.length;i++) {
        let newMsg = result.data.groupMessages[i];
        let duplicate = msgs.find(item => item.message_id === newMsg.message_id);
        if (!duplicate) {
          currentGroup.Messages.unshift(newMsg);
        }
      }
      this.gettingMessages = false;
      return true;
      
      //msgs = msgs.sort((a, b) => a.message_id - b.message_id);
      //console.log('called getMessages, result: ', result);
      //console.log(msgs);
      
      //Vue.set(currentGroup, 'Messages', msgs);
      
    },
    printMessagesCursor: function() {
    },
    getGroupMembers: async function () {
      console.log('getGroupMembers');
      const variables = { groupId: this.group.msg_group_id }
      let result = await global.apollo.query({ query: groupMembersQry, variables, fetchPolicy: 'network-only' });
      Vue.set(this.group, 'MsgGroupMembers', result.data.groupMembers);
      console.log('called getMegGroupMembers, result: ', result);
    },
    getMsgGroupQueue:  async function () {
      console.log('getGroupQueue');
      const variables = { groupId: this.group.msg_group_id }
      let result = await global.apollo.query({ query: queueForMsgGroupQry, variables, fetchPolicy: 'network-only' });
      Vue.set(this, 'queue', result.data.queueForMsgGroup);
      //Vue.set(this.queue, 'AstQueueDevices', result.data.queueForMsgGroup.AstQueueDevices);
      console.log(this.queue);
      console.log('called getGroupQueue, result: ', result);
    },
    getGroupNumber: async function () {
      const variables = { groupId: this.group.msg_group_id }
      let result = await global.apollo.query({ query: groupNumberQry, variables, fetchPolicy: 'network-only' });
      Vue.set(this.group, 'phone_number', result.data.groupNumber.phone_number);
      Vue.set(this.group, 'conference_id', result.data.groupNumber.conference_id);
      console.log('called getGroupNumebr, result: ', result);
    },
    handleKeyDown: function(e) {
      console.log('is something happening?');
      /*
      if (e.ops && e.ops[1] && e.ops[1].insert) {
        if (e.ops[1].insert == "\n") {
          this.sendMessage();
          
          
          let el = document.getElementById('vueEditor');
          try {
            //el.innerText = '';
            console.log(el.innerHTML);
            el.innerHTML = '<div class="ql-editor" data-gramm="false" contenteditable="true"></div><div class="ql-clipboard" contenteditable="true" tabindex="-1"></div>';
          } catch (e) {
            console.log(e);
          }
          
        }
      }
      */
      /*
      if (e.keyCode == 13 && !e.shiftKey) {
        //e.preventDefault();
        this.sendMessage();
      }
      */
    },
  },
  watch: {
    group: async function(oldVal, newVal) {
      await this.getMessages();
      this.getGroupMembers();
      this.getGroupNumber();
      this.getMsgGroupQueue();
      this.newMessage = '';
      if (newVal.unread_messages > 0) {
        this.$store.dispatch('setReadAllMessagesInGroup', newVal.msg_group_id);
        newVal.unread_messages = 0;
      }
      scrollToBottom();
    }
  },
  async mounted() {
    //let el = document.getElementById('vueEditor');
    //el.addEventListener('keydown', this.handleKeyDown);

    this.getGroupMembers();
    this.getGroupNumber();
    this.getMsgGroupQueue();
    await this.getMessages();
    scrollToBottom();
  },
  async beforeDestroy() {
    //let el = document.getElementById('vueEditor');
    //el.removeEventListener('keydown', this.handleKeyDown);
  },
})
</script>


<style lang='scss' scoped>



@import "~vue2-editor/dist/vue2-editor.css";
@import '~quill/dist/quill.core.css';
@import '~quill/dist/quill.bubble.css';
@import '~quill/dist/quill.snow.css';


/*--------------------
Mixins
--------------------*/
@mixin center {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@mixin ball {
  @include center;
  content: '';
  display: block;
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: rgba(255, 255, 255, .5);
  z-index: 2;
  margin-top: 4px;
  animation: ball .45s cubic-bezier(0, 0, 0.15, 1) alternate infinite;
}
.v-text-field__slot input {
text-align: center;
}

/*--------------------
Body
--------------------*/
*,
*::before,
*::after {
  box-sizing: border-box;
}

html,
body {
  height: 100%;
}

body {
  background: linear-gradient(135deg, #044f48, #2a7561);
  background-size: cover;
  font-family: 'Open Sans', sans-serif;
  line-height: 1.3;
  overflow: hidden;
}

.bg {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  background: url('https://images.unsplash.com/photo-1451186859696-371d9477be93?crop=entropy&fit=crop&fm=jpg&h=975&ixjsv=2.1.0&ixlib=rb-0.3.5&q=80&w=1925') no-repeat 0 0;
  filter: blur(80px);
  transform: scale(1.2);
}


.invisible {
  display: none;
}

/*--------------------
Chat
--------------------*/
.chat {
  // @include center;
  width: 100%;
  height: calc(100vh - 66px);
  max-height: calc(100vh - 66px);
  z-index: 2;
  overflow: hidden;
  box-shadow: 0 5px 30px rgba(0, 0, 0, .2);
  background:rgb(252, 251, 242);
  // border-radius: 20px;
  display: flex;
  justify-content:start;
  flex-direction: column;
  bottom: 0px;
}


/*--------------------
Chat Title
--------------------*/
.chat-title {
  flex: 0 1 45px;
  position: relative;
  z-index: 2;
  
  text-transform: uppercase;
  text-align: left;
  padding: 10px 10px 10px 50px;

  h1, h2 {
    font-weight: normal;
    font-size: 12px;
    margin: 0;
    padding: 0;
  }

  h2 {
    color: #aaa;
    font-size: 10px;
    letter-spacing: 1px;
  }

  .avatar {
    position: absolute;
    z-index: 1;
    top: 8px;
    left: 9px;
    border-radius: 30px;
    width: 30px;
    height: 30px;
    overflow: hidden;
    margin: 0;
    padding: 0;
    border: 2px solid rgba(255, 255, 255, 0.24);

    img {
      width: 100%;
      height: auto;
    }
  }
}

.v-text-field.v-input {
  text-align:center;
}

#profileImage {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #257D6E;
  font-size: 25px;
  color: #fff;
  text-align: center;
  line-height: 40px;
  margin: 0px 0px 0px;
}


>>> .msg > p {
  margin-bottom:0;
}

.vueEditor{
  height:100%;
  width:100%;
 }

/*--------------------
Messages
--------------------*/
.messages {
  flex: 1 1 auto;
  color: black;
  background:rgb(255, 255, 255);
  overflow-y: scroll;
  position: relative;
  height:100%;
  width: 100%;
  padding: 0px 10px 0px 0px;

  .message {
    clear: both;
    float: left;
    padding: 6px 10px 7px;
    border-radius: 10px 10px 10px 0;
    background: white;
    margin: 8px 12px;
    margin-left: 35px;
    position: relative;
    text-shadow: 0 1px 1px rgba(0, 0, 0, .2);

    .timestamp {
      position: absolute;
      bottom: -15px;
      font-size: 12px;
      color: rgba(255, 255, 255, .3);
    }

    .messageFromName {
      color: orange;
      display: block;
      font-size: 12px;
    }

    &::before {
      content: '';
      position: absolute;
      bottom: -6px;
      border-top: 6px solid rgba(0, 0, 0, .3);
      left: 0;
      border-right: 7px solid transparent;
    }

    .avatar {
      position: absolute;
      z-index: 1;
      bottom: -15px;
      left: -35px;
      border-radius: 30px;
      width: 30px;
      height: 30px;
      overflow: hidden;
      margin: 0;
      padding: 0;
      border: 2px solid rgba(255, 255, 255, 0.24);

      img {
        width: 100%;
        height: auto;
      }
    }

    &.messagePersonal {
      float: right;
      color: #fff;
      text-align: right;
      background: linear-gradient(120deg, #248A52, #257287);
      border-radius: 10px 10px 0 10px;

      &::before {
        left: auto;
        right: 0;
        border-right: none;
        border-left: 5px solid transparent;
        border-top: 4px solid #257287;
        bottom: -4px;
      }
    }

    &:last-child {
      margin-bottom: 30px;
    }

    &.new {
      transform: scale(0);
      transform-origin: 0 0;
      animation: bounce 500ms linear both;
    }

    &.loading {

      &::before {
        @include ball;
        border: none;
        animation-delay: .15s;
      }

      & span {
        display: block;
        font-size: 0;
        width: 20px;
        height: 10px;
        position: relative;

        &::before {
          @include ball;
          margin-left: -7px;
        }

        &::after {
          @include ball;
          margin-left: 7px;
          animation-delay: .3s;
        }
      }
    }

  }
}



/*--------------------
Message Box
--------------------*/
.message-box {
  flex: 0 1 40px;
  width: 100%;
  height: 10%;
  background: white;
  padding: 0px;
  position: relative;

  textarea:focus:-webkit-placeholder{
      color: transparent;
  }

  & .message-submit {
    position: absolute;
    z-index: 1;
    top: 0px;
    right: 0px;
    color: #fff;
    border: none;
    background: #248A52;
    text-transform: uppercase;
    line-height: 1;
    padding: 6px 10px;
    outline: none!important;
    transition: background .2s ease;
    width: 100px;
    height: 100%;

    &:hover {
      background: #1D7745;
    }
  }
}


/*--------------------
Custom Srollbar
--------------------*/
.mCSB_scrollTools {
  margin: 1px -3px 1px 0;
  opacity: 0;
}

.mCSB_inside > .mCSB_container {
  margin-right: 0px;
  padding: 0 10px;
}

.mCSB_scrollTools .mCSB_dragger .mCSB_dragger_bar {
  background-color: rgba(0, 0, 0, 0.5)!important;
}

.datetime {
  opacity: 0.7;
  font-size: 80%;
}

</style>
